var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlagiarism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D67C4",
    fillRule: "evenodd",
    d: "M.222 17.21A4 4 0 0 1 4.216 13h47.568a4 4 0 0 1 3.994 4.21l-1.578 30A4 4 0 0 1 50.205 51H5.795a4 4 0 0 1-3.994-3.79l-1.58-30Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.94 44.253c-1.391.484-2.885.747-4.44.747C21.044 45 15 38.956 15 31.5S21.044 18 28.5 18 42 24.044 42 31.5c0 1.46-.232 2.866-.66 4.183l-.168-.168L32.686 44l.253.253Zm.779.78c-1.62.624-3.38.967-5.219.967C20.492 46 14 39.508 14 31.5S20.492 17 28.5 17 43 23.492 43 31.5c0 1.746-.309 3.42-.874 4.97l6.117 6.116a6 6 0 1 1-8.486 8.485l-6.038-6.038Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "m33.93 41.172 4.242-4.243 7.779 7.778a3 3 0 1 1-4.243 4.243l-7.778-7.778Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 31.5,
    r: 12,
    fill: "#373737"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31.5,
    r: 6,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31.5,
    r: 4,
    fill: "#5D67C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M10 7h36v4H10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M10 3h10v1h1V2H10a4 4 0 0 0-4 4v5h2v-1H7V6a3 3 0 0 1 3-3Zm-1 7v1h12V5h-1v5H9Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlagiarism);
export default __webpack_public_path__ + "static/media/plagiarism.dfcd9e026ea5e8289acbf7439b901c05.svg";
export { ForwardRef as ReactComponent };